import axios from 'axios';

import config from '../config/urlConfig';
import formatAxiosError from '../util/formatAxiosError';
import axiosOptions from '../const/axios-options'
import * as querystring from 'querystring'
export default class {

    static gets(limit) {
        let query = querystring.stringify({ limit: limit })
        return axios
            .get(`${config.app.api}/api/sukien/gets?${query}`, axiosOptions)
            .then(response => {
                return response.data.suKiens;
            })
            .catch(error => {
                let formatedError = formatAxiosError(error);
                throw formatedError;
            });
    }
}
